// extracted by mini-css-extract-plugin
module.exports = {"spacing":"8px","grid_content":"1200px","grid_content_narrow":"864px","grid_content_wider":"1400px","grid_margin":"24px","grid_padding":"24px","grid_spacer":"24px"};